|
<template>
  <div>
    <menu-content-container
      border-full
      :chip="$t('forms.dynamic_data_feed')"
      chip-secondary
    >
      <content-row>
        <t-auto-complete
          v-model="feedQuery"
          data-testid="dynamic-feed-autocomplete"
          :data="feedsData"
          :placeholder="$t('forms.data_feed')"
          :label="$t('forms.data_feed')"
          :load-more-fnc="() => {}"
          :total-records="feedsData.length"
          :loading="feedLoading"
          @selection-changed="handleSelectFeed"
        >
        </t-auto-complete>
      </content-row>

      <content-row>
        <t-input
          v-model="identifier"
          data-testid="dynamic-identifier"
          :label="$t('forms.dynamic_identifier')"
          placeholder="Identifikátor"
        ></t-input>
      </content-row>

      <content-row>
        <t-input
          v-model="content"
          data-testid="dynamic-content"
          :label="$t('forms.dynamic_content')"
          placeholder="Klíč"
        ></t-input>
      </content-row>
    </menu-content-container>

    <menu-content-container border-full>
      <content-row>
        <hide-on-mobile></hide-on-mobile>
      </content-row>
      <content-row>
        <hide-on-desktop></hide-on-desktop>
      </content-row>
    </menu-content-container>
  </div>
</template>

<script lang="ts" setup>
  import hideOnMobile from "./components/hideOnMobile.vue";
  import hideOnDesktop from "./components/hideOnDesktop.vue";
  import { IData } from "../../types/AutoComplete/IData";
  import { useEcmStore } from "@/stores/ecm";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TAutoComplete, TInput } from "@topol/twig-ui";
  import { AxiosInstance, AxiosStatic } from "axios";
  import { ref, Ref, getCurrentInstance, computed, onMounted } from "vue";

  const app = getCurrentInstance();

  if (app === null) {
    throw new Error("App is not defined");
  }

  const $http: AxiosStatic | AxiosInstance =
    app.appContext.config.globalProperties.$http;

  interface Feed extends IData {
    id: string;
    name: string;
    url: string;
  }

  const feedLoading = ref(true);
  const feedQuery = ref("");
  const feedsData: Ref<Feed[]> = ref([]);
  const selectedFeed: Ref<Feed | null> = ref(null);

  const ecmStore = useEcmStore();
  const mjmlStore = useMjmlStore();

  const identifier = computed({
    get() {
      let content = mjmlStore.getActiveBlockPropString("identifier");
      if (content) {
        return content.replace("<!--[CDATA[", "").replace("]]-->", "");
      } else {
        content = "email";
      }
      return content;
    },
    set(val: string) {
      mjmlStore.updateBlockProp({
        prop: "identifier",
        value: val,
      });
    },
  });

  const content = computed({
    get() {
      const content = mjmlStore.getActiveBlockPropString("content");
      if (content) {
        return content.replace("<!--[CDATA[", "").replace("]]-->", "");
      }
      return content;
    },
    set(val: string) {
      mjmlStore.updateBlockProp({
        prop: "content",
        value: val,
      });
    },
  });

  function handleSelectFeed(feed: Feed) {
    feedQuery.value = feed.name;
    selectedFeed.value = feed;

    mjmlStore.updateBlockProp({
      prop: "feed",
      value: feed.id,
    });
  }

  onMounted(async () => {
    if (ecmStore.dataFeedsURL === undefined) {
      console.error(`Data feeds url is not defined in the Topol Options.`);
      return;
    }

    try {
      const res = await $http.get(ecmStore.dataFeedsURL);

      if (res.data.data) {
        feedsData.value = res.data.data;
      }
      feedLoading.value = false;
    } catch (err) {
      console.error(
        `Fetching data feeds at url: ${ecmStore.dataFeedsURL} failed.`
      );
    }

    const feedId = mjmlStore.getActiveBlockPropString("feed");

    if (feedId !== "" && feedId != null) {
      const feedToBeSelected = feedsData.value.filter(
        (feed) => feed.id === feedId
      );
      if (feedToBeSelected.length > 0) {
        selectedFeed.value = feedToBeSelected[0];
        feedQuery.value = feedToBeSelected[0].name;
      }
    }
  });
</script>
